
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {INotificationFilterTypeStrategy} from '../types/INotificationFilterTypeStrategy'
import {AllNotificationFilterTypeStrategy} from '../strategies/AllNotificationFilterTypeStrategy'
import {AssignedToMeNotificationFilterTypeStrategy} from '../strategies/AssignedToMeNotificationFilterTypeStrategy'
import {MentionsNotificationFilterTypeStrategy} from '../strategies/MentionsNotificationFilterTypeStrategy'
import {INotificationFilterTypeStrategyFactory} from '../types/INotificationFilterTypeStrategyFactory'
import {UnreadNotificationFilterTypeStrategy} from '../strategies/UnreadNotificationFilterTypeStrategy'

export class NotificationFilterTypeStrategyFactory implements INotificationFilterTypeStrategyFactory {
  getStrategy(type: NotificationFilterType): INotificationFilterTypeStrategy {
    switch (type) {
    case NotificationFilterType.All:
      return new AllNotificationFilterTypeStrategy()
    case NotificationFilterType.AssignedToMe:
      return new AssignedToMeNotificationFilterTypeStrategy()
    case NotificationFilterType.Mentions:
      return new MentionsNotificationFilterTypeStrategy()
    case NotificationFilterType.Unread:
      return new UnreadNotificationFilterTypeStrategy()
    default:
      throw new Error(`Strategy for ${type} is not implemented`)
    }
  }
}
  
